module.exports = __webpack_public_path__ + "img/28.5bc7c48a.png";